import {
  createLeadsInCalculationTablesSlice,
  LeadsInCalculationTablesSlice,
} from "@/features/calculations/slices/leadsInCalculation";
import {
  createPenaltyLeadsInPenaltyCalculationTablesSlice,
  PenaltyLeadsInPenaltyCalculationTablesSlice,
} from "@/features/penaltyCalculations/slices/leadsInPenaltyCalculation";
import {
  createSelectedItemsSlice as createSelectedItemsTariffSlice,
  SelectedItemsSlice as SelectedItemsTariffSlice,
} from "@/features/tariffs/slices/selectedItems";
import {
  createSelectedItemsSlice as createSelectedItemsUserSlice,
  SelectedItemsSlice as SelectedItemsUserSlice,
} from "@/features/users/slices/selectedItems";
import { create } from "@/lib/zustand-create";
import { createModalsSlice, ModalsSlice } from "./slices/modals";
import { createTablesSlice, TablesSlice } from "./slices/tables";
import {
  createDateParamsSlice,
  DateParamsSlice,
} from "@/features/reportsPortfolio/slices/dateParams";
import {
  NotificationsSlice,
  updateNotificationsSlice,
} from "@/components/notifications/slices/notifications";
import {
  createReportParamsSlice,
  ReportParamsSlice,
} from "@/features/reports/slices/reportDateParams";
import {
  ArchiveParamsSlice,
  createArchiveParamsSlice,
} from "@/features/archive/slices/archiveDateParams";
import {
  CalculationParamsSlice,
  createCalculationParamsSlice,
} from "@/features/calculations/slices/calculationDateParams";
import {
  createPenaltyCalculationParamsSlice,
  PenaltyCalculationParamsSlice,
} from "@/features/penaltyCalculations/slices/penaltyCalculationDateParams";

export type Store = TablesSlice &
  ModalsSlice &
  SelectedItemsTariffSlice &
  SelectedItemsUserSlice &
  LeadsInCalculationTablesSlice &
  PenaltyLeadsInPenaltyCalculationTablesSlice &
  DateParamsSlice &
  ReportParamsSlice &
  ArchiveParamsSlice &
  CalculationParamsSlice &
  PenaltyCalculationParamsSlice &
  NotificationsSlice;

export const useStore = create<Store>((...a) => ({
  ...createTablesSlice(...a),
  ...createModalsSlice(...a),
  ...createSelectedItemsTariffSlice(...a),
  ...createSelectedItemsUserSlice(...a),
  ...createLeadsInCalculationTablesSlice(...a),
  ...createPenaltyLeadsInPenaltyCalculationTablesSlice(...a),
  ...createDateParamsSlice(...a),
  ...createReportParamsSlice(...a),
  ...createArchiveParamsSlice(...a),
  ...updateNotificationsSlice(...a),
  ...createCalculationParamsSlice(...a),
  ...createPenaltyCalculationParamsSlice(...a),
}));
